export default "__VITE_ASSET__C0j0izJ6__"